export const KMS_WIDGET_NAMESPACE = 'widget.kms'
